import API from 'services/api';

const api = new API();
const API_URL = '/api/custom_ai_dimensions';

export const getCustomAIDimensions = () => {
    return new Promise((resolve, reject) => {
        api.getJson(API_URL, {
            method: 'GET',
            credentials: 'include',
            params: {},
        })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });
};

export const updateCustomAIDimension = data => {
    return new Promise((resolve, reject) => {
        api.getJson(API_URL, {
            method: 'POST',
            credentials: 'include',
            body: data,
        })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });
};

export const deleteCustomAIDimension = id => {
    return new Promise((resolve, reject) => {
        api.getJson(API_URL, {
            method: 'DELETE',
            credentials: 'include',
            body: { id },
        })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });
};

export const improveDescription = (description, displayName) => {
    return new Promise((resolve, reject) => {
        api.getJson(`${API_URL}/improve_description`, {
            method: 'POST',
            credentials: 'include',
            body: { description, display_name: displayName },
        })
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });
};
